import Papa from 'papaparse';

import sliceHeaderTiles from './sliceHeaderTiles';

export default filePath => {
    return new Promise((resolve, reject) => {
        Papa.parse(filePath, {
            download: true,

            complete: results => {
                const items = results.data;
                const itemsWithoutHeaderTiles = sliceHeaderTiles(items);

                resolve(itemsWithoutHeaderTiles);
            },
            error: err => {
                reject(err);
            }
        });
    });
};
